<template>
  <div id="login">
    <Header></Header>
    <div class="login__bg flex flex1 justify-center items-center">
      <div class="login__container flex column items-center">
        <img :src="IMAGE_LOGO" alt="二维码管理" />
        <div class="login__panel">
          <el-form ref="form" :rules="rules" :model="form" label-width="0">
            <el-form-item class="media-title-form">
              <div style="display: flex; justify-content: flex-start; align-items: center">
                <label class="login__title">找回密码</label>
              </div>
            </el-form-item>
            <el-form-item style="margin-bottom: 1.5rem" prop="UserName">
              <el-input v-model="form.UserName" placeholder="手机号/邮箱"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 1.5rem" prop="Code">
              <div style="display: flex; justify-content: space-between; align-items: center">
                <el-input v-model="form.Code" placeholder="验证码"></el-input>
                <el-button
                  type="primary"
                  class="sendcode"
                  :disabled="codeDisabled"
                  @click="sendCode"
                >
                  {{ vocode }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item style="margin-bottom: 1.5rem" prop="Password">
              <el-input
                v-model="form.Password"
                placeholder="设置新密码"
                show-password
                auto-complete="new-password"
                minlength="8"
                maxlength="12"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 1rem" prop="ResetPassword">
              <el-input
                v-model="form.ResetPassword"
                placeholder="再次输入密码"
                show-password
                auto-complete="new-password"
                minlength="8"
                maxlength="12"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 2rem">
              <el-button
                type="primary"
                class="sumbit"
                size="large"
                style="margin-top: 16px"
                :disabled="formDisabled"
                @click="changePlatformPassword"
              >
                提交
              </el-button>
            </el-form-item>
            <el-form-item style="margin-bottom: 0">
              <div style="display: flex; justify-content: center; align-items: center">
                已有账号，<el-link type="primary" :underline="false" @click="tologin">
                  登录
                </el-link>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import { mapMutations } from 'vuex'

export default {
  name: 'ResetPassword',
  components: {
    Header,
  },
  props: {},
  data() {
    const checkHasUserName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入注册手机号/邮箱'))
      }
      if (!(this.isEmail(this.form.UserName) || this.isPhone(this.form.UserName))) {
        callback(new Error('请输入正确的手机号/邮箱格式'))
      }
      // if (window.checkHasCharacters(value)) {
      //     callback(new Error('不能包含以下非法字符< >'))
      // }
      callback()
    }
    const checkValidPassword = (rule, value, callback) => {
      const reg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,12}/
      if (!reg.test(value)) {
        callback(new Error('请输入8-12位数字、字母、特殊字符组合的密码'))
      }
      // if (window.checkHasCharacters(value)) {
      //     callback(new Error('不能包含以下非法字符< >'))
      // }
      callback()
    }
    const checkHasResetPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      }
      if (this.form.Password !== this.form.ResetPassword) {
        callback(new Error('两次输入的密码不相同'))
      }
      // if (window.checkHasCharacters(value)) {
      //     callback(new Error('不能包含以下非法字符< >'))
      // }
      callback()
    }
    return {
      form: {
        UserName: null,
        Password: null,
        ResetPassword: null,
        Code: null,
      },
      rules: {
        UserName: [
          { validator: checkHasUserName, trigger: 'blur' },
          { required: true, message: '请输入手机号/邮箱', trigger: 'blur' },
        ],
        Password: [
          { validator: checkValidPassword, trigger: 'blur' },
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        ResetPassword: [
          { validator: checkHasResetPassword, trigger: 'blur' },
          { required: true, message: '请再次输入密码', trigger: 'blur' },
        ],
        Code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      formDisabled: false,
      vocode: '发送验证码',
      totalTime: 60,
      IMAGE_LOGO: require('@/assets/images/bg/logo.svg'),
      codeDisabled: true,
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        if (this.isEmail(this.form.UserName) || this.isPhone(this.form.UserName)) {
          this.codeDisabled = false
        } else {
          this.codeDisabled = true
        }
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapMutations(['setRouter']),
    tologin() {
      this.setRouter({ name: 'Login' })
    },
    // 重置密码
    changePlatformPassword() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const formData = new FormData()
          formData.append('account', this.form.UserName)
          formData.append('token', this.form.Code)
          formData.append('newPassword', this.form.Password)
          const { success } = await this.$http({
            url: this.$api.resetPassword,
            method: 'post',
            data: formData,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
          })
          if (success) {
            this.$message({
              message: '密码重置成功',
              type: 'success',
            })
            this.tologin()
          }
        }
      })
    },
    // 判断是否是邮箱
    isEmail(str) {
      let isEmail = false
      const re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      if (re.test(str)) {
        isEmail = true
      }
      return isEmail
    },
    // 判断是否是手机号
    isPhone(phone) {
      let isPhone = false
      const re = /^1\d{10}$/
      if (re.test(phone)) {
        isPhone = true
      }
      return isPhone
    },
    // 发送验证码
    async sendCode() {
      const { success } = await this.$http({
        url: this.$api.sendCode,
        params: {
          userAccount: this.form.UserName,
          type: 'resetPassword',
        },
      })
      if (success) {
        this.codeDisabled = true
        const clock = window.setInterval(() => {
          this.totalTime--
          this.vocode = `${this.totalTime.toString().padStart(2, '0')}秒后重新发送`
          if (this.totalTime === 0) {
            this.codeDisabled = false
            window.clearInterval(clock)
            this.vocode = '重新发送验证码'
            this.totalTime = 60
          }
        }, 1000)
        this.$message({
          message: '发送成功',
          type: 'success',
        })
      }
    },
  },
}
</script>

<style lang="scss">
.sendcode {
  margin-left: 1rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  padding: 14px 19px;
  border-radius: 4px;
}
#login {
  width: calc(100vw);
  height: calc(100vh);
  background: linear-gradient(0deg, #3d6b99, #163a5b);
  .login__bg {
    height: calc(100%);
    background-image: url('../assets/images/bg/bg_login.png');
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: bottom;
    background-size: 95%;

    .login__container {
      img {
        height: 42px;
      }

      .login__panel {
        width: 360px;
        margin-top: 32px;
        padding: 55px 68px 28px;
        border: 1px solid #dcdcdc;
        background: #ffffff;
        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.16);

        .login__title {
          font-size: 20px;
          font-weight: 700;
          line-height: 18px;
          text-align: left;
          color: #222222;
        }
      }
    }
  }

  .sumbit {
    font-size: 14px;
    font-weight: 700;
    width: 100%;
    line-height: 18px;
    color: #ffffff;
    border: 1px solid #dcdcdc;
    border-radius: 5px;
    background: linear-gradient(90deg, #3d6b99 1%, #163a5b 99%);
  }

  ::v-deep .el-checkbox__label {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #888888;
  }

  ::v-deep .el-checkbox__inner {
    border: 1px solid #dcdcdc;
    background: #ffffff;
  }

  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    color: #1598d9;
    border: 1px solid #1598d9;
    background: #1598d9;
  }

  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #1598d9;
  }
}

// .el-input__inner {
//     height: 3rem;
//     line-height: 3rem;
// }

// .el-link--primary {
//     color: #1598d9
// }

// .el-button--primary {
//     height: 3rem;
//     line-height: 3rem;
//     padding: 0 20px;
//     font-weight: bold;
//     width: 100%;
//     background: linear-gradient(90deg,#3d6b99 1%, #163a5b 99%) !important;
//     border: none;
// }

// .el-button--primary.is-disabled {
//     opacity: 0.8
// }

// // .el-button--info {
// //     height: 3rem;
// //     line-height: 3rem;
// //     padding: 0;
// //     font-weight: bold;
// //     background-color: #1598d9 !important;
// //     border: none;
// //     margin-left: 1rem;
// //     min-width: 7rem;
// // }

// .el-button--info.is-disabled {
//     opacity: 0.8
// }

// .el-form-item__content {
//     line-height: normal;
// }
</style>
